module.exports = function() {
  return new Worker(__webpack_public_path__ + "e3cc7731429c6c7bdaff.worker.js");
};